import React from "react";
import {
  View,
  StyleSheet,
  TextStyle,
  ViewStyle,
  Text,
  TouchableOpacity,
} from "react-native";
import { Link } from "react-router-dom";
import { NormalText } from ".";

type BannerType = "trial" | "info" | "warning" | "success";

interface BannerProps {
  type?: BannerType;
  text: string;
  daysLeft?: number;
}

type StylesType = {
  bannerContainer: ViewStyle;
  bannerContent: ViewStyle;
  bannerText: TextStyle;
  upgradeButton: ViewStyle;
  upgradeButtonText: TextStyle;
  trialContainer: ViewStyle;
  trialText: TextStyle;
  infoContainer: ViewStyle;
  infoText: TextStyle;
  warningContainer: ViewStyle;
  warningText: TextStyle;
  successContainer: ViewStyle;
  successText: TextStyle;
  [key: string]: ViewStyle | TextStyle;
};

const Banner: React.FC<BannerProps> = ({ type = "info", text, daysLeft }) => {
  const displayText =
    type === "trial" && daysLeft !== undefined
      ? `⏳ Trial active: ${daysLeft} days left to transform your clinic.`
      : text;

  return (
    <View style={[styles.bannerContainer, styles[`${type}Container`]]}>
      <View style={styles.bannerContent}>
        <NormalText text={displayText} style={styles.bannerText as TextStyle} />
        {type === "trial" && (
          <Link to="/upgrade">
            <TouchableOpacity style={styles.upgradeButton}>
              <Text style={styles.upgradeButtonText}>Upgrade Now</Text>
            </TouchableOpacity>
          </Link>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  bannerContainer: {
    width: "100%",
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  bannerContent: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: 12,
  },
  bannerText: {
    fontSize: 14,
    fontWeight: "500",
    textAlign: "center",
  },
  upgradeButton: {
    // backgroundColor: "#00B7F4",
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderRadius: 6,
  },
  upgradeButtonText: {
    color: "#000",
    fontWeight: "600",
    fontSize: 14,
  },
  trialContainer: {
    backgroundColor: "#F8F2E2",
    borderBottomColor: "#E5DAC0",
  },
  trialText: {
    color: "#7D6E55",
  },
  infoContainer: {
    backgroundColor: "#E3F2FD",
    borderBottomColor: "#BBDEFB",
  },
  infoText: {
    color: "#1976D2",
  },
  warningContainer: {
    backgroundColor: "#FFF3E0",
    borderBottomColor: "#FFE0B2",
  },
  warningText: {
    color: "#E65100",
  },
  successContainer: {
    backgroundColor: "#E8F5E9",
    borderBottomColor: "#C8E6C9",
  },
  successText: {
    color: "#2E7D32",
  },
}) as StylesType;

export default Banner;
